import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Grid, FormControl, InputLabel, Select, MenuItem, TextField
} from "@mui/material";

const StatusModal = ({
  statusModalOpen,
  statusForm,
  orderStatuses,
  handleStatusChange,
  handleSaveStatus,
  setStatusModalOpen
}) => {
  return (
    <Dialog open={statusModalOpen} onClose={() => setStatusModalOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>Change Order Status</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Select Status</InputLabel>
              <Select
                name="status_id"
                label="Select New Status"
                value={statusForm.status_id}
                onChange={handleStatusChange}
                style={{ padding: "10px", borderRadius: "4px" }}
              >
                <MenuItem value="">Select Status</MenuItem>
                {orderStatuses.map((status) => (
                  <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="description"
              label="Description"
              multiline
              minRows={3}
              value={statusForm.description}
              onChange={handleStatusChange}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setStatusModalOpen(false)}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          sx={{ color: "white" }}
          onClick={handleSaveStatus}
          disabled={!statusForm.status_id}
        >Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default StatusModal;